import { DataTableHeader } from "vuetify";

export interface IDataTableHeader<T = any> extends DataTableHeader<T> {
    databaseColumn?: string;
    expandableColumn?: boolean;
    isRequired?: boolean;
    tooltipMessage?: string;
}
